module.exports = __webpack_public_path__ + "static/media/resume.4f2de167.pdf";